import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

import type { LossAndDamageClaimPrintFormInfo } from '../../types';

export interface GetLADClaimPrintFormRequestParams {
  ClaimKeys: string;
}

export const getLADClaimPrintFormAPI = (params: GetLADClaimPrintFormRequestParams) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.LOSS_AND_DAMAGE}/GetMultiplePrintForm`,
  });
};

export type LADClaimPrintFormResponse = LossAndDamageClaimPrintFormInfo[];

export const fetchLADClaimPrintForm = async (
  params: GetLADClaimPrintFormRequestParams,
): Promise<LADClaimPrintFormResponse> => {
  const response: AxiosResponse<LADClaimPrintFormResponse> = await getLADClaimPrintFormAPI(params);
  return response.data;
};
